import { useFormContext, useWatch } from "react-hook-form";

import { FieldGroup } from "@/components/ui/field";
import { FormCombobox } from "components/BaseForm";
import { useRegionCountry } from "hooks/useRegionCountry";

const LocationSection = () => {
  const { setValue } = useFormContext();
  const regionId = useWatch({ name: "region_id" });
  const { regions, countries } = useRegionCountry({ regionId });

  return (
    <FieldGroup className="tw:grid tw:grid-cols-1 tw:gap-5 tw:md:grid-cols-2">
      <FormCombobox
        name="region_id"
        label="Region"
        required
        placeholder="Pick a Region"
        options={regions}
        onValueChange={next => {
          if (next !== regionId) {
            setValue("country", null, { shouldDirty: true });
          }
        }}
      />
      <FormCombobox
        name="country"
        label="Country"
        required
        placeholder="Pick a Country"
        options={countries}
        disabled={!regionId}
      />
    </FieldGroup>
  );
};

export default LocationSection;
